document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    const toggle = item.querySelector(".faq-toggle");
    const content = item.querySelector(".faq-content");

    toggle.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      faqItems.forEach((el) => {
        el.classList.remove("active");
        const elContent = el.querySelector(".faq-content");
        elContent.style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});
